module.exports = __webpack_public_path__ + "img/bexterno.bed55bef.svg";